export default {
	required: 'Required',
	short: 'At least 8 characters',
	long: 'Max of 750 characters',
	email: 'Should be email',
	shortHostMessage: 'Message is too short.',
	longHostMessage: 'Message is too long.',
};
